// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import utils from './utils/index.js'
import api from './api/index.js'
import echarts from 'echarts'
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import axios from 'axios';
import "babel-polyfill"
import echartswordcloud from 'echarts-wordcloud';
import Confirm from '@/components/confirm/confirm'
import store from './store/index.js';
Vue.prototype.$confirm = Confirm.install;
import { Loading,Tree, Input,Slider,Checkbox,CheckboxGroup,Table, TableColumn,Progress,Radio,RadioGroup} from 'element-ui';
import drowDowns from '@/components/form/drowDown/index'
Vue.use(drowDowns);
Vue.use(Tree);
Vue.use(Input);
Vue.use(vuescroll);
Vue.use(Slider);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Loading)
Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.prototype.$echarts = echarts
Vue.prototype.$axios=axios
//更具开发环境来配置静态资源文件的地址前缀
if(process.env.NODE_ENV === 'development'){
    //开发环境下的图片地址前缀
    Vue.prototype.$imgHttp = 'https://bsddata.oss-cn-hangzhou.aliyuncs.com';
}else{
    //生产环境下的图片地址前缀
    //本地化部署地址
    // if(window.location.protocol == 'https:'){
    //     Vue.prototype.$imgHttp = `https://${window.location.host}/images`;
    // }else{
    //     Vue.prototype.$imgHttp = `http://${window.location.host}/images`;
    // }
    //线上地址
    Vue.prototype.$imgHttp = 'https://bsddata.oss-cn-hangzhou.aliyuncs.com';
}
// 监听方案选择变化
Vue.prototype.resetSetItem = function (key, newVal) {
    if (key === 'planStorage') {

        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val);

                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
}
Vue.prototype.$newsIsRead = '#808080'
Vue.prototype.$mapOssMapUrl = 'https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_briefdoc_new/static/map/json/server/oem/old'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
//   components: { App },
  render: h => h(App),//(SEO添加)
  mounted () {//(SEO添加)
    document.dispatchEvent(new Event('render-event'))
  },
//   template: '<App/>'
})


//  检测方案跳转
router.beforeEach((to, from, next) => {
    // 登录检测
    if (to.meta.requireAuth) { // 验证是否需要登录
        let cooke = document.cookie.indexOf("xiaohuozi");
        console.log('浏览器cooke：',cooke)
        if (cooke != -1) { // 查询本地存储信息的方案信息
             //普通用户没有方案进去个人信息页面
            //  console.log('浏览器cooke：',cooke,sessionStorage.getItem('havePlanid')=='null',sessionStorage.getItem('userInfo')==0,to.name =='舆情总揽')
             if((to.name == '舆情总揽' || to.name == '信息汇总') && sessionStorage.getItem('havePlanid')=='null' && sessionStorage.getItem('userInfo')==0){
                utils.alertText('您的账号没有创建方案权限，请联系管理员分配方案');
                next({
                    path: '/vipRight'
                });
            }
            // 方案检测
            if (to.matched.some(res => res.meta.planCut)) { // 验证是否需要方案
                if (sessionStorage.getItem('planStorage')) { // 查询本地存储信息的方案信息
                    next();
                } else {
                    utils.alertText('当前没有方案，请先创建方案！');
                    next({
                        path: '/analysis/buildSolution'
                    });
                }
            } else {
                next();
            }
        } else {
            next({
                path: '/'
            });
        }
    } else {
        next();
    }
    let title = sessionStorage.getItem('pageTitle');
    let touteName = to.name;//页面的title
    if(touteName === 'index'){//首页
        document.title = title
    }else{
        document.title = to.meta.title + title
    }

});



// WEBPACK FOOTER //
// ./src/main.js